/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import NavLink from 'components/NavLink';
import Box from 'base-ui/dist/Box';
import Row from 'base-ui/dist/Row';
import Col from 'base-ui/dist/Col';
import Icon from 'base-ui/dist/Icon';
import Heading from 'base-ui/dist/Heading';
import { intl } from 'components/LocaleProvider';
import { useAuth } from 'root/hooks/useAuth';
import messages from './messages';
import apiClient from '../../lib/apiClient';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const PostCard = dynamic(() => import('components/PostCard'));

const RelatedDiseasesBox = ({ posts, disease }) => {
  const { stateUser } = useAuth();
  const { isAuthenticated } = stateUser;
  const [bookmarks, setBookmarks] = useState([]);

  useEffect(() => {
    const getBookmarks = async () => {
      const result = await apiClient({ baseURL: publicRuntimeConfig.BASE_API_URL, method: 'GET', url: '/bookmarks/ids' });

      if (result.length > 0) setBookmarks(result.map(({ id }) => id));
    };

    if (isAuthenticated) {
      getBookmarks();
    }
  }, [isAuthenticated]);

  return (
    <Box tag="section" className="section-more-articles margin-top-big margin-bottom-medium">
      <Heading type="h3">
        <NavLink
          basePath={publicRuntimeConfig.PUBLIC_URL}
          as={`${disease?.permalink}`}
          to={`/category?permalink=${disease?.permalink}`}
          routerStrategy={'next'}
        >
          {disease?.name}
          <span>
            <strong>{intl.formatMessage(messages.seeMore)}</strong>
            <Icon prefix="fas" name="chevron-right" />
          </span>
        </NavLink>
      </Heading>
      <Row>
        {posts.map((item) => (
          <Col xs="12" sm="6" key={item.id}>
            <PostCard
              post={item}
              page={'disease'}
              titleType="h4"
              isCard
              isAuthenticated={isAuthenticated}
              bookmarks={bookmarks}
              handleBookmarks={setBookmarks}
            />
          </Col>
        ))}
      </Row>
    </Box>
  );
};

RelatedDiseasesBox.propTypes = {
  posts: PropTypes.array,
  disease: PropTypes.object
};

RelatedDiseasesBox.defaultProps = {
  posts: [],
  disease: {}
};

export default RelatedDiseasesBox;
